import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import {loadableReady} from '@loadable/component';
import App from './App/index';
import {SSRDataContext} from './helpers/SSRDataContext';

const root = document.getElementById('app');
const ssrData = window.__SSR_DATA__ || null;

if (root.hasChildNodes()) {
    // SSR-rendered page — hydrate
    loadableReady(() => {
        ReactDOM.hydrate(
            <SSRDataContext.Provider value={ssrData}>
                <App />
            </SSRDataContext.Provider>,
            root
        );
    });
} else {
    // Non-SSR fallback — full render
    ReactDOM.render(
        <SSRDataContext.Provider value={ssrData}>
            <App />
        </SSRDataContext.Provider>,
        root
    );
}
